export const API_VALIDATE_PASSWORD = "/auth/validate-passcode";

export const API_STORE_DATA = "/store";

/**
 * Conversations apis
 */
export const API_FETCH_CONVERSATION = "/get-conversations";
export const API_CREATE_NEW_CONVERSATION = "/conversations";
export const API_FETCH_CONVERSATION_LIST = "/conversations";

/**
 * Archived Conversation
 */
export const API_ARCHIVE_CONVERSATION = "/archive";
export const API_ARCHIVE_ALL_CONVERSATION = "/archive/all";

// agent SSE endpoints
export const API_CHAT_RUNS = "/chat/runs";

// client completion
export const API_USER_CLIENTS = "/user/clients";

// per-message feedback
export const API_SUBMIT_FEEDBACK = "/feedback";
